<template>
  <div class="navbar">
    <div class="logo-cover">
      <img class="logo" src="@/assets/images/logo.png" alt="logo" />
      <h3 class="brand">Shahroz Saleem</h3>
    </div>
    <div class="actions-cover">
      <vs-button @click="contact">Contact</vs-button>
      <vs-button href="files/resume.pdf" target="_blank">Resume</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      active: "guide"
    };
  },
  methods: {
    contact() {
      document.querySelector(".contact").scrollIntoView({
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
.navbar {
  padding: 5px 5vw;
  position: fixed;
  z-index: 100;
  top: 0px;
  width: calc(100% - 17px);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  /* box-shadow: 0 5px 10px -4px rgba(0, 0, 0, 0.1); */
}

.logo-cover,
.actions-cover {
  background: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 15px;
}

.logo {
  width: 40px;
  margin: 3px;
  background: white;
}

.brand {
  margin-left: 10px;
}
</style>
